import * as locationAPI from './location-api';
import normalizeLocation from './normalize-location';
import { GEOLOCATION_EXPIRY_TIME, GEOLOCATION_FAILURE_EXPIRY_TIME  } from '../constants';

export const setAPIOrigin = locationAPI.setAPIOrigin;

export function fetchGeonames(geonames, defaultLocation) {
	geonames = [].concat(geonames);
	return locationAPI.fetchGeonames(geonames)
		.then(body =>
			body.documents && body.documents.reduce((acc, current) => {
				let normalized = normalizeLocation(current);
				if (!normalized.geoname_id || !normalized.postal_code) return acc;
				acc.push(normalized);
				return acc;
			}, [])
		)
		.catch(e => [defaultLocation]);
}

export function fetchGeoLocation(defaultLocation) {
	return locationAPI.fetchGeoLocation()
		.then((location) => {
			const response = normalizeLocation(location);
			response.expiry = Date.now() + GEOLOCATION_EXPIRY_TIME;
			return response;
		})
		.catch(() => {
			console.warn('LocationModel: Could not Geolocate, using default geolocation.'); // eslint-disable-line no-console
			const response = normalizeLocation(defaultLocation);
			response.expiry = Date.now() + GEOLOCATION_FAILURE_EXPIRY_TIME;
			return response;
		});
}

export function search(searchTerm, international) {
	//return empty promise on invalid input
	if (!searchTerm) return Promise.resolve([]);
	return locationAPI.search(searchTerm, international)
		.then(body => {
			if (body.documents && body.count > 0) {
				body.documents = body.documents.reduce((cleanedArray, loc) => {
					// to be useful, we need a result with a city or a postal_code
					if (!loc.city_name || !loc.postal_code) return cleanedArray;
					cleanedArray.push(normalizeLocation(loc, searchTerm));
					return cleanedArray;
				}, []);
				return body.documents;
			}
			return [];
		});
}
